<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="switchTariffs"
        :items="switchTariffs"
        :fields="switchTariffsFields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selectedSwitchTariff"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      switchTariffsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'instant_change', label: this.$i18n.t('Instant change'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val === 1 ? this.$t('Yes') : this.$t('No') }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedSwitchTariff: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  components: {
    editModal
  },
  methods: {
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Switch tariff"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_SWITCH_TARIFFS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_SWITCH_TARIFFS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedSwitchTariff = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditSwitchTariffsetting', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedSwitchTariff = {
        data: [],
        group_id: 0,
        id: 0,
        instant_change: false,
        instant_change_count: 0,
        is_enabled: 0,
        priority: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditSwitchTariffsetting', '#btnShow')
    }
  },
  computed: {
    switchTariffs () {
      return this.$store.getters['Settings/SWITCH_TARIFFS']
    },
    groups () {
      return this.$store.getters['Users/GROUPS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_SWITCH_TARIFFS')
    this.$store.dispatch('Users/GET_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/switchTariff/main.vue